export enum DurationTypes {
  Semester = 'semester',
  Hour = 'hour',
  Day = 'day',
  Month = 'month',
  Year = 'year',
  Minute = 'minute',
}

export enum DurationTypesLabels {
  Semester = 'Semestre',
  Hour = 'Hora',
  Day = 'Dia',
  Month = 'Mês',
  Year = 'Ano',
  Minute = 'Minuto',
}

export enum ModalityTypes {
  Online = 'online',
  LiveOnline = 'live_online',
  Hybrid = 'hybrid',
  InPerson = 'presential',
  PrivateClass = 'private_class',
}

export enum ModalityLabels {
  Online = 'Online',
  LiveOnline = 'Online ao vivo',
  Hybrid = 'Híbrido',
  InPerson = 'Presencial',
  PrivateClass = 'Aula particular',
}

export enum CourseTypes {
  NonDegree = 'non_degree',
  Languages = 'languages',
  Undergraduate = 'undergraduate',
  Postgraduate = 'postgraduate',
  Technical = 'technical',
  Mentorship = 'mentorship',
}

export enum CourseTypesLabels {
  NonDegree = 'Cursos Livres',
  Languages = 'Idiomas',
  Undergraduate = 'Graduação',
  Postgraduate = 'Pós-graduação',
  Technical = 'Cursos Técnicos',
  Mentorship = 'Mentoria',
}

export enum PriceTypes {
  Installments = 'installments',
  Monthly = 'monthly',
  UponRequest = 'upon_request',
  OnDemand = 'on_demand',
  Tuition = 'tuition',
  OneOff = 'one_off',
}

export interface CourseType {
  type: CourseTypes;
  label: CourseTypesLabels;
}

export interface Duration {
  type: DurationTypes;
  quantity: number;
}

export interface Modality {
  type: ModalityTypes;
  label: ModalityLabels;
}

export interface CheckoutConfig {
  charging_amount?: number;
  charging_percentage?: number;
  has_extra_payment: boolean;
}

export interface Institution {
  id: number;
  name: string;
  about: string | null;
  logo_url: string | null;
  logo_background_color: string | null;
  checkout_config?: CheckoutConfig;
}

export interface Course {
  id: number;
  offer_city: string;
  offer_hub: number;
  offer_id: number;
  offer_period: string;
  offer_state: string;
  offers_quantity: number;
  institution_name: string | null;
  institution: Institution;
  course_name: string;
  course_type: CourseType;
  duration: Duration;
  discount_percentage: number;
  price_with_discount: number;
  original_price: number;
  price_type: PriceTypes;
  installments: number;
  modalities: Modality[];
  knowledge_areas?: string[];
  subscribed_at?: string;
  hash_key?: string;
}
